<template lang="pug">
page-template.px-lg-15.mb-10(
  title="SALA DE MATRÍCULAS",
  fluid,
  title-align="center"
)
  .mb-6
    img.w-100(:src="files + banner")
  grid-container(cols="auto", cols-md="auto 484px", gap="40px")
    div
      div(v-if="video")
        .text-h5.font-weight-bold.mb-3.primary--text SOBRE O COLÉGIO JEAN PIAGET SINOP - MT
        iframe.page-prematricula-video.rounded(
          :src="`https://www.youtube.com/embed/${getYoutubeCode(video)}`",
          frameborder="0",
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
          allowfullscree,
          n
        )
      .mt-4
        v-expansion-panels(dark)
          v-expansion-panel.mb-4(
            v-for="{ id, title, attachments } in education",
            :key="id"
          )
            v-expansion-panel-header.primary
              div
                span.font-weight-bold.text--darken-4 {{ title }}
            v-expansion-panel-content.pt-4.px-2.white.black--text
              template(v-if="attachments.length")
                v-card.d-flex.justify-space-between.pa-3.align-center.mb-3(
                  v-for="({ title, path }, i) in attachments",
                  :key="i",
                  outlined,
                  light
                ) 
                  .font-weight-bold.grey--text.text--darken-3 {{ title }}
                  v-btn.rounded-pill(
                    :href="files + path",
                    target="_blank",
                    color="primary",
                    small,
                    depressed
                  )
                    v-icon(small, left) fas fa-download
                    span.text-none Download
              div(v-else) Nenhum conteúdo adicionado.
    div
      section
        .text-h5.mb-3.font-weight-bold.primary--text REALIZAR MATRÍCULA
        v-btn.text-none.white--text.rounded-pill.mb-4(
          :href="whatsAppLink",
          target="_blank",
          color="#00e676",
          depressed,
          block,
          :height="xs ? '50px' : '60px'"
        )
          v-icon.mr-2.mr-sm-4(:size="xs ? '30px' : '40px'") fab fa-whatsapp
          span.text-h6.text-sm-h4.font-weight-bold Fale Conosco
        pre-registration(:action="server + '/rest/email/pre-registration'")
      section
        .text-h5.mb-3.font-weight-bold INFORMAÇÕES
        div(v-if="informations.local")
          v-btn.text-none(
            :href="informations.local_link",
            target="_blank",
            icon
          )
            v-icon(small) fas fa-map-marked-alt
          span.barlow Local: {{ informations.local }}
        div(v-if="informations.operation")
          v-btn.text-none(target="_blank", icon)
            v-icon(small) fas fa-clock
          span.barlow Horas: {{ informations.operation }}
        div(v-if="informations.tel")
          v-btn.text-none(
            :href="getTelLinkFromPhone(informations.tel)",
            target="_blank",
            icon
          )
            v-icon(small) fas fa-phone
          span.barlow Telefone: {{ informations.tel }}
        div(v-if="informations.email")
          v-btn.text-none(
            :href="'mailto:' + informations.email",
            target="_blank",
            icon
          )
            v-icon(small) fas fa-envelope
          span.barlow E-mail: {{ informations.email }}
  .py-4
    .text-h5.font-weight-bold.primary--text NOSSO DIFERENCIAIS
    v-divider.pt-1.primary.mb-6
    grid-container.px-2(
      gap="16px",
      cols="auto auto",
      cols-sm="auto auto auto",
      cols-md="auto auto auto auto"
    )
      project-card.mb-3.white--text(
        v-for="({ img, title, text, to }, i) in projects",
        :key="i",
        :to="to",
        :img="img",
        :title="title",
        :text="text",
        large
      )
  .mt-8(v-if="doubts.length")
    .text-h5.font-weight-bold.primary--text DÚVIDAS FREQUENTES
    v-divider.pt-1.primary.mb-4
    v-expansion-panels
      v-expansion-panel(v-for="{ id, question, answer } in doubts", :key="id")
        v-expansion-panel-header
          div
            v-icon.mt-n1(small, left) fas fa-question
            span.font-weight-bold.grey--text.text--darken-4 {{ question }}
        v-expansion-panel-content {{ answer }}
</template>

<script>
import PageTemplate from "@/components/templates/Page.vue";
import PreRegistration from "@/components/forms/PreRegistration";
import ProjectCard from "@/components/cards/Project";
import { getTelLinkFromPhone, getYoutubeCode } from "@/components/utils.js";
import { formatToURL, getWhatsappLinkFromPhone } from "../utils";

export default {
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    video() {
      return this.$rest("about").item.video;
    },
    education() {
      return this.$rest("education").list;
    },
    doubts() {
      return this.$rest("registrationDoubts").list;
    },
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    banner() {
      return this.$rest("registrationInformation").item.banner;
    },
    whatsAppLink() {
      const whatsapp = this.informations.whatsapp;
      return whatsapp ? getWhatsappLinkFromPhone(whatsapp) : "";
    },
    projects() {
      return this.$rest("projects").list.map(({ id, title, img, text }) => ({
        title,
        img: this.files + img,
        to: `/novidades/projetos/${formatToURL(title)}-${id}`,
        text,
      }));
    },
  },
  methods: {
    getTelLinkFromPhone,
    getYoutubeCode,
  },
  beforeCreate() {
    this.$rest("about").get({ save: (state, data) => (state.item = data) });
    this.$rest("registrationDoubts").get();
    this.$rest("registrationInformation").get({
      save: (state, data) => (state.item = data),
    });
    this.$rest("education").get();
    this.$rest("projects").get();
  },
  components: {
    PageTemplate,
    PreRegistration,
    ProjectCard,
  },
};
</script>

<style>
.page-prematricula-video {
  aspect-ratio: 16/9;
  width: 100%;
}
</style>